import React from 'react';
import  {useRef} from 'react';
import {Link} from "react-router-dom";
import imageOnError from '../helpers/imgOnError.js';

interface CopyLinkProps {
    link?: string;
    anchor?: string;
}

export default function CopyLink({link, anchor }: CopyLinkProps) {
	if (!link) return (<></>);
	if (!anchor) return (<></>);

    let clipboardControl = useRef<HTMLSpanElement>(null);	
	
	let url = link + '#' + anchor;
    function clipboardCopy(): boolean {
		navigator.clipboard.writeText(url);
		return false;
    }

	return (
		<>
            <span className="wts-pass-text"  ref={clipboardControl}	
				style={{ cursor: 'pointer', pointerEvents: 'auto', color: 'blue'}}>
				{' '}            
				<i   onClick={clipboardCopy}               
					className="mdi mdi-content-copy" 
					aria-disabled="true"
					style={{ fontSize: '14px',verticalAlign: 'text-top'}}
					title = "Copy anchor to clipboard"
				/>
            </span>
		</>
	)
/*	
return (
		<>
            <span className="wts-pass-text"  ref={clipboardControl}	>
				{' '}
				<Link to={`#${anchor}`}  onClick={() => console.log('Button clicked!')}
					className="link-hover"
				 	title="Copy link to clipboard">                  
					<i                  
						className="mdi mdi-content-copy" 
						aria-disabled="true"
					/>
				</Link> 
            </span>
		</>
	)
	return (
		<>
            <span className="wts-pass-text"  ref={clipboardControl}	>
				{' '}
				<a href={url} onClick = {clipboardCopy}
					className="link-hover"
				 	title="Copy link to clipboard">                  
				<i                  
					className="mdi mdi-content-copy" 
					aria-disabled="true"
				/>
				</a>
            </span>
		</>
	)*/
}